import React from "react"
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { TitleAnimation } from '../index'
// import { LinkButton } from "../index"
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitWorks.module.scss"

const RecruitWorks = () => {

  // const breakpoints = useBreakpoint();

  const title1 = [
    { "id": 0, "text": "w" },
    { "id": 1, "text": "o" },
    { "id": 2, "text": "r" },
    { "id": 3, "text": "k" },
    { "id": 4, "text": "s" },
  ];

  return (
      <div className={styles.RecruitWorks}>
        <div className={styles.RecruitWorks__inner}>
          <TitleAnimation data={title1} className={`titleRubikCenter`} />
          <h2 className={`subH2`}>業務内容</h2>
            <div className={styles.RecruitWorks__content}>
              <ul>
                <li>
                  <div className={styles.RecruitWorks__img}>
                    <StaticImage
                      src="../../images/recruit/top/works1@2x.png"
                      alt="総合食品製造業チキンの生産・処理・販売"
                      placeholder="blurred"
                    />
                  </div>
                  <div className={styles.RecruitWorks__text}>
                    総合食品製造業チキンの生産・処理・販売
                  </div>
                </li>
                <li>
                  <div className={styles.RecruitWorks__img}>
                    <StaticImage
                      src="../../images/recruit/top/works2@2x.png"
                      alt="養鶏用飼料・資材・器具・薬品・ヒナ等の販売"
                      placeholder="blurred"
                    />
                  </div>
                  <div className={styles.RecruitWorks__text}>
                    養鶏用飼料・資材・器具・薬品・ヒナ等の販売
                  </div>
                </li>
                <li>
                  <div className={styles.RecruitWorks__img}>
                    <StaticImage
                      src="../../images/recruit/top/works3@2x.png"
                      alt="鶏卵肉の加工食品、冷凍食品の製造・販売"
                      placeholder="blurred"
                    />
                  </div>
                  <div className={styles.RecruitWorks__text}>
                    鶏卵肉の加工食品、冷凍食品の製造・販売
                  </div>
                </li>
                <li>
                  <div className={styles.RecruitWorks__img}>
                    <StaticImage
                      src="../../images/recruit/top/works4@2x.png"
                      alt="菓子類の製造・販売"
                      placeholder="blurred"
                    />
                  </div>
                  <div className={styles.RecruitWorks__text}>
                    菓子類の製造・販売
                  </div>
                </li>
                <li>
                  <div className={styles.RecruitWorks__img}>
                    <StaticImage
                      src="../../images/recruit/top/works5@2x.png"
                      alt="肥料の製造・販売"
                      placeholder="blurred"
                    />
                  </div>
                  <div className={styles.RecruitWorks__text}>
                    肥料の製造・販売
                  </div>
                </li>
              </ul>
            </div>
        </div>
      </div>
  )
}
export default RecruitWorks

